import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ArticlesComponent } from './articles.component';
import { AuthGuard } from '../../auth/auth-guard.service';
import { ArticleComponent } from './article.component';

const routes: Routes = [
  {
    path: '',
    component: ArticlesComponent, canActivate: [AuthGuard],
    data: { permissions: ['adminAccess']},
    children: [

      {
        path: 'listing/:type',
        component: ArticleComponent,
        canActivate: [AuthGuard],
        data: { permissions: ['adminAccess', 'adminEditUser']},
      },
    ]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ArticlesRoutingModule { }

export const routedComponents = [
  ArticlesComponent,
  ArticleComponent
];
